"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Menu = function Menu(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.159 6.72H3.839c-.64 0-1.12-.52-1.12-1.12 0-.6.52-1.12 1.12-1.12h12.28c.64 0 1.12.52 1.12 1.12 0 .6-.48 1.12-1.08 1.12zM16.159 11.08H3.839c-.64 0-1.12-.52-1.12-1.12 0-.6.52-1.16 1.12-1.16h12.28c.64 0 1.12.52 1.12 1.12 0 .6-.48 1.16-1.08 1.16zM16.161 15.56h-6.76c-.64 0-1.12-.52-1.12-1.12 0-.6.52-1.12 1.12-1.12h6.76c.64 0 1.12.52 1.12 1.12 0 .6-.52 1.12-1.12 1.12z",
    fill: color
  }));
};
var _default = exports["default"] = Menu;